<template>
  <div class="xcard">
    <h3 class="text-center">Menu de asignaciones</h3>
    <hr />

    <v-row>
      <v-col
        v-if="ismauren || (ispermitido && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 25 || $store.state.CARGO.id == 26 || is_rol_administrador)"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacionesv2ts')">
            <v-img
              src="https://thumbs.dreamstime.com/b/inversi%C3%B3n-en-el-futuro-del-ejemplo-vector-concepto-de-dise%C3%B1o-plano-para-la-las-finanzas-y-actividades-bancarias-elegantes-l%C3%ADnea-147763815.jpg"
              height="150px"></v-img>

            <v-card-title>
              Recaudacion Total <br />
              por Unidad Negocio
            </v-card-title>

            <v-card-subtitle> Asignacion por unidades. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacionesv2tsp')">
            <v-img
              src="https://thumbs.dreamstime.com/b/hombres-de-negocios-financieros-la-inversi%C3%B3n-que-aumentan-el-capital-y-beneficios-riqueza-ahorros-con-los-caracteres-dinero-las-136291027.jpg"
              height="150px"></v-img>

            <v-card-title> Recaudación total por sede </v-card-title>

            <v-card-subtitle> Asignacion total por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_prog')">
            <v-img src="https://www.theinit.com/wp-content/uploads/2021/04/FINANZAS.png" height="150px"></v-img>

            <v-card-title> Recaudación total por programa </v-card-title>

            <v-card-subtitle> Asignacion total por programas. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col v-if="ispermitido || $store.state.CARGO.id == 26 || is_rol_administrador" cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_corpo')">
            <v-img
              src="https://www.workday.com/content/dam/web/en-us/images/content/abstract-article-4@2x.png/jcr:content/renditions/original"
              height="150px"></v-img>

            <v-card-title> Recaudación Corporacion </v-card-title>

            <v-card-subtitle> Asignacion total. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col v-if="ispermitido && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 25 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacionesv2c')">
            <v-img
              src="https://static.vecteezy.com/system/resources/thumbnails/006/170/572/small/flat-design-of-financial-literacy-education-free-vector.jpg"
              height="150px"></v-img>

            <v-card-title> Certificaciones </v-card-title>

            <v-card-subtitle> Asignacion de todos los programas por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('recaudacionv4')">
            <div class="d-flex flex-column align-center justify-center py-6 rounded-t-xl"
              style="background-color: #2e7d32;">
              <v-icon size="64" color="white" class="mb-2">mdi-cash-multiple</v-icon>
              <v-chip color="light-green lighten-1" text-color="white" small label class="font-weight-bold">
                NUEVO
              </v-chip>
            </div>

            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase">
              Recaudacion Por Sede
            </v-card-title>

            <v-card-subtitle class="text-center text-body-2 px-3">
              Nueva funcionalidad para recaudacion por sede.
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-card-actions class="justify-center pb-3">
              <v-btn color="primary" text small>
                Ingresar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>

        </template>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('asignacion_prog_v4')">
            <div class="d-flex flex-column align-center justify-center py-6 bg-primary rounded-t-xl">
              <v-icon size="64" color="white" class="mb-2">mdi-cash-check</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">
                NUEVO
              </v-chip>
            </div>

            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase">
              Asignación Por Programa
            </v-card-title>

            <v-card-subtitle class="text-center text-body-2 px-3">
              Nueva funcionalidad para asignar programas por sede.
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-card-actions class="justify-center pb-3">
              <v-btn color="primary" text small>
                Ingresar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>

        </template>
      </v-col>
      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto hoverable transition-all" elevation="5" rounded="xl" color="blue-grey lighten-5"
            @click="asignacionopen('asignacion_sede_v4')">
            <div class="d-flex flex-column align-center justify-center py-6 bg-teal rounded-t-xl">
              <v-icon size="64" color="white" class="mb-2">mdi-map-marker-multiple</v-icon>
              <v-chip color="pink lighten-2" text-color="white" small label class="font-weight-bold">
                NUEVO
              </v-chip>
            </div>

            <v-card-title class="text-center font-weight-bold mt-2 text-uppercase">
              Asignación por Sedes
            </v-card-title>

            <v-card-subtitle class="text-center text-body-2 px-3">
              Nueva funcionalidad para asignar cobros según la ubicación o sede.
            </v-card-subtitle>

            <v-divider class="my-2"></v-divider>

            <v-card-actions class="justify-center pb-3">
              <v-btn color="teal" text small>
                Ingresar
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <!-- <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_sede_v4')">
            <v-img src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>

            <v-card-title> Asignaciones Sede Nuevo</v-card-title>

            <v-card-subtitle> Asignacion de los programas por cada sede. </v-card-subtitle>
          </v-card> -->
        </template>
      </v-col>
    </v-row>
    <v-row>

      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_prog_v2')">
            <v-img src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>
            <v-card-title> Asignacion por programa </v-card-title>
            <v-card-subtitle> Asignacion de los programas por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="ispermitido || $store.state.CARGO.id == 3 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_sede_v2')">
            <v-img
              src="https://media.istockphoto.com/id/1202048771/es/vector/el-personaje-del-hombre-de-negocios-exitoso-se-encuentra-en-una-postura-segura-en-enorme.jpg?s=612x612&w=0&k=20&c=KKJV2TKw4yZkpQAFdlymTZnw0bj7yHpJjaLIgWghodI="
              height="150px"></v-img>

            <v-card-title> Asignacion de Sede </v-card-title>

            <v-card-subtitle> Asignacion de los programas de una sede de cada gestion. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col v-if="ispermitido && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 25" cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_negounidad_v2')">
            <v-img
              src="https://media.istockphoto.com/vectors/business-success-flat-cartoon-style-vector-illustration-vector-id1149316200"
              height="150px"></v-img>

            <v-card-title> Asignacion Por unidad de Negocio </v-card-title>

            <v-card-subtitle> Asignacion Por unidad de Negocio </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador" cols="12" sm="4"
        lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_corporacion_v2')">
            <v-img
              src="https://thumbs.dreamstime.com/b/hombres-de-negocios-financieros-la-inversi%C3%B3n-que-aumentan-el-capital-y-beneficios-riqueza-ahorros-con-los-caracteres-dinero-las-136291027.jpg"
              height="150px"></v-img>

            <v-card-title> Asignacion Corporacion </v-card-title>

            <v-card-subtitle> Asignacion de toda la corporacion por unidades de negocio </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador" cols="12" sm="4"
        lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asignacion_prog_v3')">
            <v-img src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>

            <v-card-title> Asignacion por programa X </v-card-title>

            <v-card-subtitle> Asignacion de los programas por cada sede. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <div
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || is_rol_administrador">
      <p class="mt-4 green white--text"><b class="pl-9">Proyecciones:</b></p>
    </div>

    <v-row>
      <v-col v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador" cols="12" sm="4"
        lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('proy_unidad')">
            <v-img
              src="https://media.istockphoto.com/id/1284636492/es/vector/concepto-de-crecimiento-de-ingresos-los-empresarios-personajes-cooperaci%C3%B3n-en-equipo-team-of.jpg?s=612x612&w=0&k=20&c=_NmXk5tcH5m_mLwO5e_NryQyg_7Lp1gBrinuMabs3kA="
              height="150px"></v-img>

            <v-card-title> Proyeccion por unidad </v-card-title>

            <v-card-subtitle> Proyeccion por unidad de negocio </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('proy_programas')">
            <v-img
              src="https://thumbs.dreamstime.com/b/la-gente-que-trabaja-junta-y-desarrolla-estrategia-empresarial-al-%C3%A9xito-concepto-de-inversi%C3%B3n-crecimiento-financiero-cada-vez-120538031.jpg"
              height="150px"></v-img>

            <v-card-title> Proyeccion Programas </v-card-title>

            <v-card-subtitle> Proyeccion por programas </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('proy_sedes')">
            <v-img
              src="https://static.vecteezy.com/system/resources/thumbnails/001/363/114/small/economic-recovery-concept-vector.jpg"
              height="150px"></v-img>

            <v-card-title> Proyeccion por sede </v-card-title>

            <v-card-subtitle> Proyeccion por sede de unidad </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador" cols="12" sm="4"
        lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('proy_corporacion')">
            <v-img
              src="https://media.istockphoto.com/id/1278695302/es/vector/contabilidad-finanzas-datos-bancarios-peque%C3%B1os-personajes-contables-alrededor-de-enormes.jpg?s=170667a&w=is&k=20&c=mVvE_UQQ7vBI322VQPBKD7qud9UwqeUDvhEqIKHA1NQ="
              height="150px"></v-img>

            <v-card-title> Proyeccion corporacion </v-card-title>

            <v-card-subtitle> Proyeccion de toda la corporacion </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <div
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || $store.state.CARGO.id == 26 || is_rol_administrador">
      <p class="mt-4 purple white--text"><b class="pl-9">Asignaciones totales:</b></p>
    </div>

    <v-row>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_unidad')">
            <v-img
              src="https://media.istockphoto.com/id/1433729125/es/vector/concepto-de-negocio-de-auditor%C3%ADa-financiera-se-puede-utilizar-para-banner-web-infograf%C3%ADas.jpg?s=170667a&w=0&k=20&c=iyCv8jF0YXe8HJbc6vNd7rPczfdjEVgmhfz77TdiWJY="
              height="150px"></v-img>

            <v-card-title> Total por Unidad </v-card-title>

            <v-card-subtitle> Asignaciones </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_sede')">
            <v-img
              src="https://media.istockphoto.com/id/1218907275/es/vector/auditor%C3%ADa-financiera-conteo-de-dinero-c%C3%A1lculo-de-beneficios.jpg?s=612x612&w=0&k=20&c=YgGzPJa-XL9YcUFDi5J--rORh18NU92ppgXm0PzQ5DI="
              height="150px"></v-img>

            <v-card-title> Total por Sede </v-card-title>

            <v-card-subtitle> Asignaciones </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_programa')">
            <v-img
              src="https://s3.amazonaws.com/s3.timetoast.com/public/uploads/photo/16155041/image/4bdf2fe3937977acbd5aa77814ead190"
              height="150px"></v-img>

            <v-card-title> Total por Programa </v-card-title>

            <v-card-subtitle> Asignaciones </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 26 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_total_corporacion')">
            <v-img
              src="https://media.istockphoto.com/id/1216101429/es/vector/auditor-certificado-por-equipo-multi%C3%A9tnico-que-realiza-investigaci%C3%B3n.jpg?s=612x612&w=0&k=20&c=n57w8LskpmuAshaWu-smBO-trKekCN_OFm2ZXORGV9M="
              height="150px"></v-img>

            <v-card-title> Total Corporacion </v-card-title>

            <v-card-subtitle> Asignaciones </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <div
      v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || is_rol_administrador">
      <p class="mt-4 white--text" style="background:#db201b"><b class="pl-9">Envios Netsuite:</b></p>
    </div>
    <v-row>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == -25 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="asignacionopen('asig_envios_a_netsuite')">
            <v-img src="https://149527389.v2.pressablecdn.com/wp-content/uploads/2024/03/netsuite_oracle2.png"
              height="150px" width="100%"></v-img>

            <v-card-title> Enviados a Netsuite </v-card-title>

            <v-card-subtitle> Hazme click :) </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || is_rol_administrador"
        cols="12" sm="4" lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="openlink('/portal/extreme')">
            <v-img src="https://www.salient.com/wp-content/uploads/2014/10/dashboards-with-mobile-silo-MMCLOUD-web.png"
              height="150px"></v-img>

            <v-card-title> Recaudacion Recibos </v-card-title>

            <v-card-subtitle> Dev Extreme </v-card-subtitle>
          </v-card>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      estudiantes: [],
      ispermitido: false,
      ismauren: false,
      is_rol_administrador: false
    };
  },
  watch: {},
  components: {},
  methods: {
    asignacionopen(url) {
      this.$router.push({ name: url });
    },
    openlink(url) {
      window.location.href = url;
    },
  },
  mounted() {
    let cid = this.$store.state.CARGO.id;
    this.is_rol_administrador = cid == 4 || cid == 22;
    this.ismauren = this.$store.state.DATA_USER.id == 3506;
    this.ispermitido =
      this.$store.state.CARGO.id == 19 ||
      this.$store.state.CARGO.id == 14 ||
      this.$store.state.CARGO.id == 15 ||
      this.$store.state.CARGO.id == 25 ||
      this.$store.state.CARGO.id == 1;
  },
};
</script>
<style scoped>
.hoverable {
  transition: all 0.25s ease;
}

.hoverable:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.bg-primary {
  background: linear-gradient(135deg, #1976d2, #42a5f5);
}

.bg-teal {
  background: linear-gradient(135deg, #00796b, #26a69a);
}
</style>
